
'use client';

import { useState } from 'react';

export default function MenuBar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const navLinks = [
        { href: '/#home', label: 'Home' },
        { href: '/#wer-bin-ich', label: 'Über mich' },
        { href: '/#leistungen', label: 'Leistungen' },
        { href: '/#kontakt', label: 'Kontakt' },
    ];

    return (
        <>
            {/* Desktop Sidebar */}
            <nav className="hidden md:flex w-64 h-screen bg-emerald-900 text-white flex-col fixed left-0 top-0 shadow-lg">
                {/* Logo/Title */}
                <div className="p-6 border-b border-emerald-700">
                    <h1 className="text-xl font-bold tracking-wide">Annett Herrmann</h1>
                    <p className="text-xs text-emerald-100 mt-1">Mediation & Happinesstraining</p>
                </div>

                {/* Navigation */}
                <ul className="flex flex-col gap-2 p-4 flex-1">
                    {navLinks.map((link) => (
                        <li key={link.href}>
                            <a 
                                href={link.href} 
                                className="block px-4 py-3 rounded-lg hover:bg-emerald-800 transition-colors duration-200 font-medium"
                            >
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>

                {/* Footer Links */}
                <div className="p-4 border-t border-emerald-700 text-center text-xs text-emerald-200">
                    <div className="space-x-2">
                        <a href="/impressum" className="hover:text-white transition-colors">Impressum</a>
                        <span>•</span>
                        <a href="/datenschutz" className="hover:text-white transition-colors">Datenschutz</a>
                    </div>
                </div>
            </nav>

            {/* Mobile Header */}
            <div className="md:hidden fixed top-0 left-0 right-0 bg-emerald-900 text-white z-50 shadow-lg">
                <div className="flex items-center justify-between p-4">
                    <div className="flex-1">
                        <h1 className="text-lg font-bold tracking-wide">Annett Herrmann</h1>
                        <p className="text-xs text-emerald-100">Mediation & Happinesstraining</p>
                    </div>
                    <button
                        onClick={toggleMenu}
                        className="ml-4 p-2 hover:bg-emerald-800 rounded-lg transition-colors duration-200 flex-shrink-0"
                        aria-label="Menü öffnen"
                        aria-expanded={isOpen}
                    >
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {isOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            {isOpen && (
                <div 
                    className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
                    onClick={closeMenu}
                />
            )}

            {/* Mobile Full-Screen Menu */}
            {isOpen && (
                <nav className="md:hidden fixed inset-0 bg-emerald-900 text-white z-40 pt-24 flex flex-col">
                    <ul className="flex flex-col gap-0 flex-1">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <a 
                                    href={link.href} 
                                    onClick={closeMenu}
                                    className="block px-6 py-4 text-lg font-medium hover:bg-emerald-800 transition-colors duration-200 border-b border-emerald-700"
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>

                    {/* Footer Links */}
                    <div className="p-6 border-t border-emerald-700 text-center text-xs text-emerald-200">
                        <div className="space-x-2">
                            <a href="/impressum" onClick={closeMenu} className="hover:text-white transition-colors">Impressum</a>
                            <span>•</span>
                            <a href="/datenschutz" onClick={closeMenu} className="hover:text-white transition-colors">Datenschutz</a>
                        </div>
                    </div>
                </nav>
            )}
        </>
    );
}